<template>
    <div>
        <b-row>
            <b-col>
                <h5>
                    <span
                        @click="hasHistory()
                        ? $router.go(-1)
                        : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Счет
                </h5>
            </b-col>
        </b-row>
        <div class="mt-4 position-relative">
            <tsoft-finance-show-one
                v-if="!dataOverlay"
                :detailedItem="detailedItem"
            ></tsoft-finance-show-one>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </div>
</template>

<script>
    import {API_FINANCE} from "../constants"
    import tsoftFinanceShowOne from '../components/finance/FinanceShowOne'

    export default {
        components: {
            'tsoft-finance-show-one': tsoftFinanceShowOne
        },
        data() {
            return {
                dataOverlay: true,
                tableApiUrl: API_FINANCE,
                finance_id: '',
                detailedItem: {},
                componentRefreshKey: 0
            }
        },
        created() {
            this.loadOneFinance()
        },
        watch: {
            $route(to, from) {
                this.loadOneFinance()
            },
        },
        methods: {
            loadOneFinance() {
                this.dataOverlay = true
                if (this.$route.params.finance_id) {
                    this.finance_id = this.$route.params.finance_id

                    api.call("get", `${this.tableApiUrl}/${this.finance_id}`).then(({data}) => {
                        this.detailedItem = data
                        this.componentRefreshKey += 1
                        this.dataOverlay = false
                    })
                }
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
